import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand and Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2">
              <Logo />
            </div>
            <p className="text-xs mt-4 text-gray-600 max-w-md">
            111 West Lewis Street,<br/>Suite 118,<br/>Greensboro, NC 27406 
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">
              Quick Links
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link to="/#pricing" className="text-gray-600 hover:text-blue-600">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/signin" className="text-gray-600 hover:text-blue-600">
                  Sign In
                </Link>
              </li>
              <li>
                <Link to="/signup" className="text-gray-600 hover:text-blue-600">
                  Get Started
                </Link>
              </li>
              <li>
                <a href="mailto:support@arcadvantage.ai" className="text-blue-500 hover:text-blue-600">
                  support@arcadvantage.ai
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">
              Company
            </h3>
            <ul className="mt-4 space-y-4">
            <li>
                <Link to="/about" className="text-gray-600 hover:text-blue-600">
                  About Us
                </Link>
              </li>
              <li>
                <a href="https://affiliates.arcadvantage.ai/signup" className="text-gray-600 hover:text-blue-600" target="_blank" rel="noopener noreferrer">
                  Affiliates
                </a>
              </li>              
              <li>
                <Link to="/privacy" className="text-gray-600 hover:text-blue-600">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-blue-600">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm">
              © {currentYear} ArcAdvantage.ai. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}